/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".popup-container{font-family:Noto Sans Lao,Noto Sans,sans-serif;height:300px;width:auto;max-width:500px;background-color:#fff;border-radius:10px}"];
export { styles as styles };
